import { use } from 'react';
import ActivityBookingContext from '..';
const useActivityBookingAvailableTimes = () => {
    const { setFetchTimes, loadingAvailableTimes, availableTimesQueryError, availableTimes } = use(ActivityBookingContext);
    return {
        setFetchTimes,
        loadingAvailableTimes,
        availableTimesQueryError,
        availableTimes
    };
};
export default useActivityBookingAvailableTimes;
